import sumoLogo from '../images/sumo_logo.png'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'

import { Button } from '../components/button'
import { PlusIcon } from '@heroicons/react/16/solid'

import { Input } from '../components/input'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { useState, useEffect, useRef } from 'react'
import { Badge } from '../components/badge'

import { Loader } from '../components/loader';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '../components/avatar'
import { Heading, Subheading  } from '../components/heading'
import { Checkbox, CheckboxField, CheckboxGroup } from '../components/checkbox'

import { AuthLayout } from '../components/auth-layout'
import config from '../config.js'

import { ErrorNotification, SuccessNotification } from '../components/notification';
import { useAlert } from "../components/customAlert";

export default function ListCompanies() {
	const { showAlert } = useAlert();
	const navigate = useNavigate();
	const [products, setProducts] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [selectedAccounts, setSelectedAccounts] = useState([]);
	const [page, setPage] = useState(1);	
	const limit = 10;
	const [total, setTotal] = useState(0);
	const [popupMessage, setPopupMessage] = useState('');
	const [popupHeading, setPopupHeading] = useState('');
	const [loading, setLoading] = useState(false);
	const [confirmed, setConfirmed] = useState(false);//for confirmation
	let [isOpen, setIsOpen] = useState(false);
	let [isOpenConfirm, setIsOpenConfirm] = useState(false);
	const [selectedCompName, setSelectedCompName] = useState('');
	const [selectedCompCntry, setSelectedCompCntry] = useState('');
	const [selectedCompPrdt, setSelectedCompPrdt] = useState('');
	const [selectedCompMail, setSelectedCompMail] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
  	const [showErrorBox, setShowErrorBox] = useState(false);

	const [gmcEmail, setMail] = useState('');
	const [serverError, setServerError] = useState('');
	
	// Fetch paginated product data
	const fetchProducts = async (pageNum) => {
		setLoading(true); // show loader
		try {
			//const res = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch.php?gmc_mail_id=${encodeURIComponent(gmcEmail)}`,{ credentials: 'include' });
			//const res = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch.php?gmc_mail_id=feedsumodemo@gmail.com`,{ credentials: 'include' });
			
			//&gmc_mail_id=${encodeURIComponent(gmcEmail)}
			//insert token data in SUMO_GMC_ACCOUNTS & enable user
			const res = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=addAccount`,{ credentials: 'include' });
			const data = await res.json();
			//console.log(data);
			//if email session is not found, then it will call else part
			if(data.status==='success' && data.mail){
				//set mail address
				setMail(data.mail);
				
				//check if already exists in SUMO_ALL_GMC_ACCOUNTS then response = success, if not exists then response = error
				const check_exists = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=check_acc_exists&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
				const check_exists_data = await check_exists.json();
				
				//only call if account already not found - to avoid multiple fetch
				var res1 = data1 = '';
				if(check_exists_data.status==='error'){				
				  //all accounts insert cron call with specific email				
				  var res1 = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch-cron.php?process=add_account&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
				  var data1 = await res1.json();
				}
				
				if(data1.status==='success' || check_exists_data.status==='success'){					
					//collect accounts for specific email address
					const res2 = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=get_acc_list_full&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
					const data2 = await res2.json();
					
					setProducts(data2.products);
					setTotal(data2.total);
				}else{					
					setLoading(false); // hide loader
					showAlert(data1.msg, "Error" , "error",3000);
					navigate('/account-setup');					
				}
			}else{				
				setLoading(false); // hide loader
				showAlert(data.msg, "Error" , "error",3000);
				navigate('/account-setup');				
			}					
			
		} catch(error) {
			console.error("Fetch error", error);
		} finally {
			setLoading(false); // hide loader
		}
	};
	
	//to avoid duplicate requests
	const didFetch = useRef(false);
	useEffect(() => {
	  if (!didFetch.current) {
		didFetch.current = true;
		fetchProducts(page);
	  }
	}, [page]);
	
	useEffect(() => {
  	if (confirmed) {
		  setConfirmed(false); // reset flag
		  
		  //setPopupHeading('✅ Success');
		  //setPopupMessage("Add company process initiated, once completed, you will get mail");		  
		  //setIsOpen(true);		
		  console.log("added companies:", selectedIds);
		  console.log("mail:", gmcEmail);
		 
		  
		  
		  // Trigger async without await
		  setTimeout(() => {
			fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=add_company&mail=${gmcEmail}&ids=${selectedIds}`,
			{ credentials: 'include' });
		  }, 0);
		  
		  setSelectedIds([]);
		  //fetchProducts(page);
		  
		  /*setTimeout(() => {*/
		  	navigate('/data-import-progress',{ state: { gmcEmail: gmcEmail,selectedIds: selectedIds } });
		  /*}, 100);*/
		}
	}, [confirmed, page, selectedIds]);
	
	// Handle checkbox toggle
	const handleCheckboxChange = (id) => {
		if (!id) return; // prevent pushing undefined
		
		setSelectedIds((prev) => {
		  const newSelected = prev.includes(id)
			? prev.filter((item) => item !== id) // unselect
			: [...prev, id]; // select
	  
		  // get account objects from products
		  const accounts = products.filter((p) => newSelected.includes(p.sumo_account_id));
		  setSelectedAccounts(accounts);
	  
		  return newSelected;
		});		
	};
	
	const handleAddCompany = async () => {
		console.log("added companies:", selectedIds);
		if (selectedIds.length === 0) {
			//setPopupHeading('⚠️ Alert');
			//setPopupMessage('Please select at least one account to proceed.');
			//setIsOpen(true);
			showAlert('Please select at least one account to proceed.', "Error" , "error",3000);

			return;    	  	
		}
		// Show confirmation popup
		setIsOpenConfirm(true);   	
	};
	
	const handleCancel = () => {
		setSelectedIds([]);
	};
	
	return (
<AuthLayout>
	<ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	<div className="grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center">

		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-2">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-1xl ">Let's get you started</Heading>
		<Heading className="text-center !text-1xl ">OK! We have found the following accounts, select all those we should include</Heading>
		
		<Table className="max-h-[300px] [--gutter:--spacing(6)] overflow-x-auto overflow-y-auto mt-4">
			<TableHead>
				<TableRow>
					<TableHeader>Account ID</TableHeader>
					<TableHeader>Account Name</TableHeader>
					<TableHeader>Account Type</TableHeader>
					<TableHeader>GMC Type</TableHeader>
					<TableHeader>Feeds</TableHeader>
					<TableHeader>Country</TableHeader>
					<TableHeader>Products</TableHeader>
					<TableHeader>Disapproval (%)</TableHeader>
					<TableHeader>Setup</TableHeader>
				</TableRow>
			</TableHead>
			{loading ? (<Loader />) : (
			<TableBody>
				{total > 0 ?( 
					Object.values(products).map((prod) => (
					<TableRow key={prod.sumo_account_id}>
						<TableCell>{prod.merchantId}</TableCell>
						<TableCell>{prod.account_name}</TableCell>
						<TableCell><Badge color={`${prod.accountType === "MCA" ? "yellow" : "lime"}`}>{prod.accountType}</Badge></TableCell>
						<TableCell>Classic</TableCell>
						<TableCell className="text-center">{prod.feedCount}</TableCell>
						<TableCell className="text-center">{prod.country}</TableCell>
						<TableCell className="text-center">{prod.productCount}</TableCell>
						<TableCell className="text-center">{prod.dispprovePercent}</TableCell>
						<TableCell className="text-center">
							<CheckboxGroup>
								<CheckboxField>
									<Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes(prod.sumo_account_id)} onChange={() => handleCheckboxChange(prod.sumo_account_id)} />
								</CheckboxField>
							</CheckboxGroup>
						</TableCell>
					</TableRow>))
				):(<TableRow><TableCell>No Accounts Found</TableCell></TableRow>) }
			</TableBody>
			)}
		</Table>

		<Subheading className="text-center py-2">No changes will be made to your accounts, we will just sync the data over and analyse it.</Subheading>
				
		{/* Action Buttons starts*/}
		{total > 0 && (
			<div className="mt-2 flex space-x-4 justify-center">
				<Button color="white" class="w-40 cursor-pointer" onClick={handleCancel}>Clear</Button>
				<Button class="w-40 cursor-pointer" onClick={handleAddCompany}>Next</Button>
			</div>
		)}
		{/* Action Buttons ends*/}

		{/*dialog start*/}
		<Dialog open={isOpen} onClose={setIsOpen}>
			<DialogTitle>{popupHeading}</DialogTitle>
			<DialogDescription>{popupMessage}</DialogDescription>
			<DialogBody></DialogBody>
			<DialogActions>
				<Button onClick={() => setIsOpen(false)}>Close</Button>
			</DialogActions>
		</Dialog>
		{/*dialog end*/}
		
		{/*confirm dialog start*/}
		<Dialog open={isOpenConfirm} onClose={setIsOpenConfirm} size="xl">
			<DialogTitle>Confirm</DialogTitle>
			<DialogDescription>Are you sure, you want to add the below selected accounts?</DialogDescription>
			<DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
				<Table>
					<TableHead>
						<TableRow className="text-zinc-950 dark:text-white">
							<TableHeader>Account Name</TableHeader>
							<TableHeader>Country</TableHeader>
							<TableHeader>Products</TableHeader>
						</TableRow>
					</TableHead>
					<TableBody>
						{selectedAccounts.map((acc) => (
				  			<TableRow key={acc.sumo_account_id}>
								<TableCell className="text-zinc-500">{acc.account_name}</TableCell>
								<TableCell className="text-zinc-500">{acc.country}</TableCell>
								<TableCell className="text-zinc-500">{acc.productCount}</TableCell>					
				  			</TableRow>
						))}
					</TableBody>
				</Table>
			</DialogBody>
			<DialogActions>
				<Button plain onClick={() => setIsOpenConfirm(false)}>Cancel</Button>
				<Button onClick={() => {setIsOpenConfirm(false);setConfirmed(true);}}>Yes Proceed</Button>
			</DialogActions>
		</Dialog>
		{/*confirm dialog end*/} 
	</div>
</AuthLayout>
);
}